












































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';


@Component
export default class Keyboard extends Vue {
  /**
   * 键盘类型
   */
  @Prop({ default: 'number' }) public type!: 'number' | 'idcard' | 'digit';
  /**
   * 是否隐藏
   */
  @Prop({ default: true }) public hidden!: boolean;

  /**
   * 点击键盘按键
   * @param event
   */
  bindtap(event: Event) {
    const target = event.target as HTMLElement;
    const val = target.dataset.value; // 取元素data-value
    if (val) {
      this.$emit('bind-tap', {
        detail: { value: val },
      });
    }
    this.switchKeyActive(event, 'active');
  }

  /**
   * 切换键盘状态
   * @param event 事件对象
   * @param action 动作名称
   */
  switchKeyActive(event: Event, action: string) {
    const target = event.target as HTMLElement;
    if ('active' === action) {
      target.classList.add('active');
    } else {
      target.classList.remove('active');
    }
  }
}

